import React from 'react';
import logo from './img/caete-florestal-logo.png';

class Header extends React.Component {

    constructor() {

        super();

        let usuarioInfo = JSON.parse(localStorage.usuarioInfo);

        this.state = {
            nomeUsuario: usuarioInfo.nome,
            centro: usuarioInfo.centro
        };

    }

    render() {
        return (
            <div id="dashboard-header">
                <ul>
                    <li><p><b>Usuário:</b> { this.state.nomeUsuario }</p></li>
                    <li><p><b>Centro:</b> { this.state.centro }</p></li>
                </ul>
                <img src={logo} id="dashboard-logo" alt="logo" />
            </div>
        );
    }

}

export default Header;

